export default class Location {
  _key: string
  id: string
  name: string
  schedule_type: string
  internet_booking: string
  address: string
  position: string
  email: string
  phone: string

  constructor (instance: any) {
    this._key = instance._key
    this.id = instance.id
    this.name = instance.name
    this.schedule_type = instance.schedule_type
    this.internet_booking = instance.internet_booking
    this.address = instance.address
    this.position = instance.position
    this.email = instance.email
    this.phone = instance.phone
  }
}
